<template>
  <div class="box-user">
    <Navbar />
    <div class="user">
      <vue-good-table
        :search-options="{ enabled: true }"
        :columns="columns"
        :rows="rows"
        :sort-options="{ enabled: false }"
        @on-row-click="selectUser"
        :pagination-options="{
          enabled: true,
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [10, 25, 50],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'ถัดไป',
          prevLabel: 'ก่อนหน้า',
          rowsPerPageLabel: 'จำนวนข้อมูลต่อหน้า',
          ofLabel: 'จาก',
        }"
      >
        <div slot="table-actions">
          <b-button
            @click="callModalAdd"
            size="sm"
            style="margin-right:10px; background-color:#005a7c"
          >
            <font-awesome-icon icon="plus" />&nbsp;เพิ่มบัญชีผู้ใช้
          </b-button>
        </div>
      </vue-good-table>
    </div>
    <b-modal ref="modal-user-add" size="sm" title="บัญชีผู้ใช้" hide-footer centered>
      <b-container>
        <b-row class="mt-2">
          <b-col>
            <b-row>
              <b-col lg="5">
                ชื่อบัญชี
                <span class="required">&nbsp;*</span>
              </b-col>
              <b-col>
                <b-form-input size="sm" v-model="user.username" ref="username" required></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-row>
              <b-col lg="5">
                ชื่อ-สกุล
                <span class="required">&nbsp;*</span>
              </b-col>
              <b-col>
                <b-form-input size="sm" v-model="user.fullname" ref="fullname" required></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-row>
              <b-col lg="5">
                รหัสผ่าน
                <span class="required">&nbsp;*</span>
              </b-col>
              <b-col>
                <b-form-input
                  type="password"
                  v-model="user.password"
                  ref="password1"
                  size="sm"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-row>
              <b-col lg="5">
                ยืนยันรหัสผ่าน
                <span class="required">&nbsp;*</span>
              </b-col>
              <b-col>
                <b-form-input type="password" v-model="password" size="sm" ref="password2" required></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-row>
              <b-col lg="5">
                อายุการใช้งาน
                <span class="required" v-if="isPartner === '0'">&nbsp;*</span>
              </b-col>
              <b-col>
                <b-row>
                  <b-col lg="12" md="12" sm="12">
                    <div class="input-group">
                      <b-form-input
                      :disabled="isPartner === '1'"
                        size="sm"
                        type="number"
                        v-model="user.countDate"
                        ref="countDate"
                      ></b-form-input>
                      <div class="input-group-append">
                        <span class="input-group-text ml-3">วัน</span>
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="12" md="12" sm="12">
                    <b-form-checkbox v-model="isPartner" value="1" unchecked-value="0">เป็น Partner</b-form-checkbox>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-3 text-center">
          <b-col>
            <b-button variant="success" size="sm" @click="addUser">บันทึกข้อมูล</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal ref="modal-user-update" size="sm" hide-footer centered title="บัญชีผู้ใช้">
      <b-container>
        <b-row class="mt-2">
          <b-col lg="5">
            ชื่อผู้ใช้
            <span class="required">&nbsp;*</span>
          </b-col>
          <b-col>
            <b-form-input v-model="update.username" ref="uusername" size="sm"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col lg="5">
            ชื่อ-สกุล
            <span class="required">&nbsp;*</span>
          </b-col>
          <b-col>
            <b-form-input v-model="update.fullname" ref="ufullname" size="sm"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col lg="5">
            วันหมดอายุ
            <span class="required">&nbsp;*</span>
          </b-col>
          <b-col>
            <b-form-input v-model="update.expiration_date" ref="uexp" size="sm"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col lg="5">
            สถานะ
            <span class="required">&nbsp;*</span>
          </b-col>
          <b-col>
            <b-form-select size="sm" v-model="update.status" :options="option_status"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mt-4 text-center">
          <b-col>
            <b-button variant="primary" size="sm" @click="updateUser">บันทึกข้อมูล</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <Footer />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "./Footer";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
export default {
  components: { Navbar, Footer, VueGoodTable },
  data() {
    return {
      isPartner: '0',
      password: null,
      user: {
        username: null,
        fullname: null,
        password: null,
        expiration_date: null,
        countDate: null
      },
      option_status: [
        { value: "0", text: "ปิดการใช้งาน" },
        { value: "1", text: "เปิดการใช้งาน" }
      ],
      update: {
        oldusername: null,
        username: null,
        fullname: null,
        status: null,
        expiration_date: null
      },
      rows: [],
      columns: [
        {
          label: "ชื่อบัญผู้ใช้",
          field: "username",
          width: "15%"
        },
        {
          label: "ชื่อสกุล",
          field: "fullname"
        },
        {
          label: "หมดอายุ",
          field: "expiration_date",
          width: "10%"
        },
        {
          label: "เหลือ (วัน)",
          field: "amountDate",
          width: "10%"
        }
      ]
    };
  },
  mounted() {
    axios
      .get("https://www.kmppartners.info:1030/api/ebidding/user_customer/all")
      .then(res => {
        if (res.data.status) {
          this.rows = res.data.response;
        }
      });
  },
  methods: {
    selectUser: function(params) {
      axios
        .post("https://www.kmppartners.info:1030/api/ebidding/get/customer", {
          username: params.row.username
        })
        .then(res => {
          if (res.data.status) {
            this.update.oldusername = res.data.response.username;
            this.update.username = res.data.response.username;
            this.update.fullname = res.data.response.fullname;
            this.update.status = res.data.response.enable;
            this.update.expiration_date = res.data.response.expiration_date;
            this.$refs["modal-user-update"].show();
          } else {
            this.$bvToast.toast(res.data.error, {
              title: "ผิดพลาด",
              autoHideDelay: 5000,
              appendToast: true,
              variant: "danger"
            });
          }
        });
    },
    callModalAdd: function() {
      this.$refs["modal-user-add"].show();
    },
    updateUser: function() {
      let pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
      if (this.update.username === null || this.update.username === "") {
        this.$bvToast.toast("กรุณากรอกชื่อบัญชีผู้ใช้", {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs['uusername'].focus()
      } else if (this.update.fullname === null || this.update.fullname === "") {
        this.$bvToast.toast("ชื่อ-สกุล", {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs['ufullname'].focus()
      } else if (
        this.update.expiration_date === null ||
        this.update.username === ""
      ) {
        this.$bvToast.toast("กรุณากรอกวันที่หมดอายุ", {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs['uexp'].focus()
      } else if (!pattern.test(this.update.expiration_date)) {
        this.$bvToast.toast(
          "กรุณากรอกวันที่ให้ถูกต้อง วว/ดด/ปปปป (01/02/2563)",
          {
            title: "ผิดพลาด",
            autoHideDelay: 5000,
            appendToast: true,
            variant: "danger"
          }
        );
        this.$refs['uexp'].focus()
      } else {
        axios
          .post(
            "https://www.kmppartners.info:1030/api/ebidding/update/customer",
            this.update
          )
          .then(res => {
            if (res.data.status) {
              this.$bvModal
                .msgBoxOk("บันทึกข้อมูลเรียบร้อยเเล้ว", {
                  title: "สำเร็จ",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                  okTitle: "ตกลง"
                }).then(value=>{
                  if(value){
                    location.reload()
                  }
                })
            } else {
              this.$bvModal
                .msgBoxOk(res.data.error, {
                  title: "ไม่สำเร็จ",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "danger",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                  okTitle: "ตกลง"
                }).then(value=>{
                  if(value){
                    location.reload()
                  }
                })
            }
          });
      }
    },
    addUser: function() {
      if (this.user.username === null || this.user.username === "") {
        this.$bvToast.toast("กรุณากรอกชื่อบัญชีผู้ใช้", {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["username"].focus();
      } else if (this.user.fullname === null || this.user.fullname === "") {
        this.$bvToast.toast("กรุณากรอกชื่อ-สกุล", {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["fullname"].focus();
      } else if (this.user.password === null || this.user.password === "") {
        this.$bvToast.toast("กรุณากรอกรหัสผ่าน", {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["password1"].focus();
      } else if ((this.user.countDate === null || this.user.countDate === "") && this.isPartner === '0' ) {
        this.$bvToast.toast("กรุณากรอกจำนวนวันการใช้งาน", {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["countDate"].focus();
      } else if (this.user.password !== this.password) {
        this.$bvToast.toast("กรุณากรอกรหัสผ่านให้ตรงกัน", {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["password2"].focus();
      } else {
        if(this.isPartner === '1'){
          this.user.countDate = 365
        }
        axios
          .post(
            "https://www.kmppartners.info:1030/api/ebidding/add/user/customer",
            this.user
          )
          .then(res => {
            if (res.data.status) {
              this.$bvModal
                .msgBoxOk("บันทึกข้อมูลเรียบร้อยเเล้ว", {
                  title: "สำเร็จ",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                  okTitle: "ตกลง"
                })
                .then(value => {
                  if (value) {
                    axios
                      .post(
                        "https://www.kmppartners.info:1030/api/ebidding/access_log",
                        {
                          access_username: this.$session.get("username"),
                          access_module: "เพิ่มผู้ใช้งาน",
                          access_ipaddress: this.$session.get("ipaddress")
                        }
                      )
                      .then(ress => {
                        if (ress.data.statusLog) {
                          location.reload();
                        }
                      });
                  }
                });
            } else {
              this.$bvModal
                .msgBoxOk(res.data.error, {
                  title: "ไม่สำเร็จ",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "danger",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                  okTitle: "ตกลง"
                })
                .then(value => {
                  if (value) {
                    location.reload();
                  }
                });
            }
          });
      }
    }
  }
};
</script>

<style>
.box-user {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
.user {
  font-family: "K2D";
  margin: 3% !important;
  padding-bottom: 12%;
}
@media (max-width: 600px) {
  .user {
    padding-bottom: 300px;
  }
}
</style>